// extracted by mini-css-extract-plugin
export var boxItems = "_8p-1";
export var boxItemsLg = "_8p-2";
export var button = "_8p-7";
export var buttonHoverless = "_8p-9";
export var buttonLg = "_8p-8";
export var filterGroupBox = "_8p-0";
export var icon = "_8p-3";
export var iconSecondary = "_8p-6";
export var iconWrapper = "_8p-4";
export var iconWrapperLg = "_8p-5";
export var truncatedLabel = "_8p-a";